import React from "react";


import ContactForm from '../ContactForm';
import Title from './Title';
import Appointment from './Appointment';
import Cost from './Cost';
import DexAddress from './DexAddress';
import DialupModes from './DialupModes';
import Records from './Records';
import Reports from './Reports';
import SystemContact from './SystemsContact';
import WorkScheme from './WorkScheme';
import Installation from './Installation';


class MainPage extends React.Component {

    componentDidMount() {
        document.title = "Dialer EXpress";
    }

    render() {
        return (
            <div className={'main'}>
                <Title/>
                <Appointment/>
                <DialupModes/>
                <WorkScheme/>
                <SystemContact/>
                <Reports/>
                <Records/>
                <Cost/>
                <Installation/>
                <DexAddress/>
                <ContactForm/>
            </div>
        )
    }
}

export default MainPage;


// WEBPACK FOOTER //
// ./src/Components/DialerExpress/DialerPage.js